import { isObject, keys } from 'lodash';

/*
 * Returns the proper value for the property of an object as follow :
 * - checks if property is an object
 * - tries to get translated property by lang in param
 * - return the translated property of the property's first lang if lang param is not in property
 * - if property is not an object, returns it as it is
 */
export function getObjectPropertyValue(obj, property, lang) {
    let translatedProperty;
    if (isObject(obj[property])) {
        translatedProperty = obj[property][lang];
        if (translatedProperty === undefined)
            translatedProperty = obj[property][keys(obj[property])[0]];
    }
    else translatedProperty = obj[property];
    return translatedProperty;
}

/*
 * Returns the proper value for the property as follow :
 * - checks if property is an object
 * - tries to get translated property by lang in param
 * - return the translated property of the property's first lang if lang param is not in property
 * - if property is not an object, returns it as it is
 */
export function getPropertyValue(property, lang) {
    let translatedProperty;
    if (isObject(property)) {
        translatedProperty = property[lang];
        if (translatedProperty === undefined)
            translatedProperty = property[keys(property)[0]];
    }
    else translatedProperty = property;
    return translatedProperty;
}
